import type { ReactNode } from 'react';

import type { Estate } from '@/features/estates-property/api/estate';
import type { Project } from '@/features/projects/api/projects';

type AdmitGuardProps = {
  children: ReactNode;
  metadata?: Estate['metadata'] | Project['metadata'] | null;
};

export const AuthorGuard = ({ metadata, children }: AdmitGuardProps) => {
  if (metadata?.canUpdate) {
    return children;
  }
};
